import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel, Navigation, } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import styles from "./Css/BookLibrary.module.css";
import { useNavigate } from "react-router-dom";
import Loading from "../../../common/HousGlass Loader/Loading";
import { useEbooksByGenreName } from "../../../hooks/useEbooksHooks";

function EbookCategoriesCarousel({ categoryName }) {
  const navigate = useNavigate();

  const { ebooks, isLoading, error } = useEbooksByGenreName(categoryName);

  // Check loading and error states
  if (isLoading)
    return (
      <div>
        <Loading />
      </div>
    );
  if (error) return null;

  const handleViewMore = (category) => {
    navigate(`/books/${category}`);
  };

  // Use ebooks directly from the hook
  const books = ebooks || [];

  return (
    books.length > 0 && (
      <div className={styles.container}>
        <div className={styles.book_slider_container}>
          <div className={styles.author_header}>
            <h2 className={styles.heading}>{categoryName}</h2>
            <span
              className={styles.view_more}
              onClick={() => handleViewMore(categoryName)}
            >
              View More {">"}
            </span>
          </div>
          <Swiper
            modules={[Navigation, Mousewheel, FreeMode]} // Add FreeMode!
            spaceBetween={20}
            navigation
            freeMode={{
              enabled: true,
              momentum: true,
              momentumRatio: 1,
              momentumVelocityRatio: 1,
              minimumVelocity: 0.02,
              sticky: false, // or true if you want light snapping after scroll
            }}
            mousewheel={{
              forceToAxis: true,
              invert: false,
              sensitivity: 0.4, // smoother wheel sensitivity
              releaseOnEdges: true,
            }}
            speed={400} // control slide transition smoothness
            resistance={true}
            resistanceRatio={0.85}
            breakpoints={{
              320: { slidesPerView: 3, spaceBetween: 10 },
              480: { slidesPerView: 3, spaceBetween: 15 },
              768: { slidesPerView: 4, spaceBetween: 20 },
              1024: { slidesPerView: 6, spaceBetween: 20 },
              1200: { slidesPerView: 7, spaceBetween: 20 },
            }}
          >
            {books.map((book) => (
              <SwiperSlide key={book.id}>
                <img
                  src={book.cover_image_url_for_computer}
                  alt={book.title}
                  style={{ cursor: "pointer" }}
                  className={styles.book_image}
                  onClick={() =>
                    navigate(
                      book.series_id
                        ? `/book-details/${book.slug}`
                        : `/book-detail/${book.slug}`
                    )
                  }
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    )
  );
}

export default EbookCategoriesCarousel;
